import { getAwrStatus } from "@/utils/workers";

export const awrFilter = value => {
  return getAwrStatus(value);
};
